// extracted by mini-css-extract-plugin
module.exports = {"title":"AddPerfume_title__JoACt","box":"AddPerfume_box__FVs-G","info":"AddPerfume_info__3FhO3","radio":"AddPerfume_radio__2-UhP","submitButton":"AddPerfume_submitButton__1r5QG"};